// For Production use
// export const ApiUrl = "http://localhost/php-react/backend";

// For Development use
export const ApiUrl = "https://mrtamilcartoon.000webhostapp.com";